export const GET_STARTED_URL = 'https://4xu6wknl4ap.typeform.com/to/xBVjgB4F';

export type SampleKind = 'plan' | 'programEvaluation';
export type SampleAudience = { admin: boolean; sisConnected: boolean; accessUploaded?: boolean; sisMatchingConfirmed?: boolean; sisMatchingRequired?: boolean };
export type SampleAction = 'getStarted' | 'uploadAccess' | null;
export type SampleBannerCopy = { title: string; body: string; action: SampleAction };

const PLAN_TITLE = 'This is a sample Student Action Plan';
const PLAN_LEAD = 'Layla Hasan is a fictional student, shown so you can see what a plan looks like.';
const PE_TITLE = 'This is a sample Program Evaluation';
const PE_LEAD =
  'Cedar Valley USD is a fictional district, shown so you can see what a Program Evaluation looks like.';
const GET_STARTED_TAIL =
  'click “Get Started” and we’ll be in touch to help you connect your SIS and upload your ACCESS data.';

export function sampleBannerCopy(kind: SampleKind, audience: SampleAudience): SampleBannerCopy {
  if (kind === 'programEvaluation') {
    if (audience.accessUploaded && audience.sisConnected && audience.sisMatchingRequired && !audience.sisMatchingConfirmed) {
      return {
        title: PE_TITLE,
        body: `${PE_LEAD} Your SIS roster and ACCESS results are in. Flashlight is matching your SIS data, and your own evaluation unlocks when it’s done.`,
        action: null,
      };
    }
    if (audience.accessUploaded && !audience.sisConnected) {
      return {
        title: PE_TITLE,
        body: `${PE_LEAD} Your ACCESS results are in. Connect your SIS to get an evaluation of your own program: click “Get Started” and we’ll be in touch.`,
        action: 'getStarted',
      };
    }
    return audience.sisConnected
      ? {
          title: PE_TITLE,
          body: `${PE_LEAD} Your SIS roster is connected. Upload your district’s WIDA ACCESS results to get an evaluation of your own program.`,
          action: 'uploadAccess',
        }
      : {
          title: PE_TITLE,
          body: `${PE_LEAD} To get one for your own district, ${GET_STARTED_TAIL}`,
          action: 'getStarted',
        };
  }
  if (!audience.admin) {
    return {
      title: PLAN_TITLE,
      body: `${PLAN_LEAD} Your own students, each with a plan, will appear here once your district uploads its WIDA ACCESS results and connects your district’s SIS roster.`,
      action: null,
    };
  }
  if (audience.accessUploaded) {
    return {
      title: PLAN_TITLE,
      body: `${PLAN_LEAD} Your district’s WIDA ACCESS results are uploaded. Once your Student Action Plans are generated, each of your English learners will have one here.`,
      action: null,
    };
  }
  return audience.sisConnected
    ? {
        title: PLAN_TITLE,
        body: `${PLAN_LEAD} Your SIS roster is connected. Upload your district’s WIDA ACCESS results to get a plan for each of your English learners.`,
        action: 'uploadAccess',
      }
    : {
        title: PLAN_TITLE,
        body: `${PLAN_LEAD} To get a plan for each of your own English learners, ${GET_STARTED_TAIL}`,
        action: 'getStarted',
      };
}
